import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SaveIcon from '@mui/icons-material/Save';
import { InfoPersonalCliente } from './InfoPersonalCliente';
import { APIURL } from '../../../configApi/apiConfig';
import axios from "../../../configApi/axiosConfig";
export function ModalGestion({ cliente, mostrarModal, onCerrar, onGuardar }) {

    console.log('ModalGestion renderizado con cliente:', cliente);
    const [tipoGestion, setTipoGestion] = useState('');
    const [notas, setNotas] = useState('');
    const [guardando, setGuardando] = useState(false);
    const [tiposGestion, setTiposGestion] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (mostrarModal) {
            fetchTiposGestion();
        }
    }, [mostrarModal]);

    const fetchTiposGestion = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(APIURL.get_motivosContinuidadRecurrente());
            setTiposGestion(response.data || []);
        } catch (error) {
            console.error('Error al cargar tipos de gestión:', error);
            setError('Error al cargar los tipos de gestión');
            setTiposGestion([]);
        } finally {
            setLoading(false);
        }
    };

    if (!mostrarModal || !cliente) return null;


    const handleGuardar = async () => {
        if (!tipoGestion || !notas.trim()) {
            alert('Por favor complete todos los campos');
            return;
        }

        setGuardando(true);

        try {
            const tipoSeleccionado = tiposGestion.find(t => t.idCbo_Continuidad === parseInt(tipoGestion));
            
            const gestion = {

                sDetalleClientesGestionBase: cliente.sDetalleClientesGestionBase,
                idMotivoContinuidad: parseInt(tipoGestion),
                Descripcion: notas,

            };

            // Aquí iría la llamada al API
            // await axios.post(APIURL.guardarGestion(), gestion);

            if (onGuardar) {
                onGuardar(gestion);
            }

            console.log('Gestión guardada:', gestion);
            
            // Resetear formulario
            setTipoGestion('');
            setNotas('');
            onCerrar();
        } catch (error) {
            console.error('Error al guardar gestión:', error);
            alert('Error al guardar la gestión. Por favor intente nuevamente.');
        } finally {
            setGuardando(false);
        }
    };

    const handleCerrarModal = () => {
        setTipoGestion('');
        setNotas('');
        onCerrar();
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={handleCerrarModal}
        >
            <div
                className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header del Modal */}
                <div className="bg-gradient-to-r from-purple-500 to-indigo-600 px-8 py-6 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-white bg-opacity-20 rounded-full">
                                <AssignmentIcon className="text-white" sx={{ fontSize: 32 }} />
                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-white">Registrar Gestión</h2>
                                <p className="text-purple-100 text-sm">Documentar interacción con el cliente</p>
                            </div>
                        </div>
                        <button
                            onClick={handleCerrarModal}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
                        >
                            <CloseIcon className="text-white" sx={{ fontSize: 24 }} />
                        </button>
                    </div>
                </div>

                {/* Contenido del Modal */}
                <div className="p-8">
                    {/* Información del Cliente */}
                    <InfoPersonalCliente cliente={cliente} />

                    {/* Formulario */}
                    <div className="space-y-6 mb-6">
                        {/* Indicador de carga */}
                        {loading && (
                            <div className="p-3 bg-blue-50 border border-blue-200 rounded-xl">
                                <p className="text-sm text-blue-700 text-center">
                                    ⏳ Cargando tipos de gestión...
                                </p>
                            </div>
                        )}

                        {/* Tipo de Gestión */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                <AssignmentIcon sx={{ fontSize: 16 }} className="inline mr-1" />
                                Tipo de Gestión *
                            </label>
                            {error && (
                                <div className="mb-2 p-2 bg-red-50 border border-red-200 rounded-lg">
                                    <p className="text-xs text-red-600">{error}</p>
                                </div>
                            )}
                            <select
                                value={tipoGestion}
                                onChange={(e) => setTipoGestion(e.target.value)}
                                disabled={loading || guardando}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-purple-500 focus:ring-purple-200 transition-all disabled:bg-gray-100 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {loading ? 'Cargando tipos de gestión...' : 'Seleccione el tipo de gestión...'}
                                </option>
                                {tiposGestion.map(tipo => (
                                    <option key={tipo.idMotivoContinuidad} value={tipo.idMotivoContinuidad}>
                                        {tipo.Nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Notas */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Notas / Observaciones *
                            </label>
                            <textarea
                                value={notas}
                                onChange={(e) => setNotas(e.target.value)}
                                placeholder="Describa los detalles de la gestión realizada..."
                                rows={6}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-purple-500 focus:ring-purple-200 transition-all resize-none uppercase"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                {notas.length} caracteres
                            </p>
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                        <button
                            onClick={handleCerrarModal}
                            disabled={guardando}
                            className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-semibold rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleGuardar}
                            disabled={guardando || !tipoGestion || !notas.trim()}
                            className="px-6 py-3 bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-semibold rounded-xl hover:from-purple-600 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                        >
                            <SaveIcon sx={{ fontSize: 20 }} />
                            {guardando ? 'Guardando...' : 'Guardar Gestión'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
